/* Funcion para dar formato de dinero a un numero */
const formatToMoney = (amount, currency) => {

    let formatted;
    
    if(currency){
        formatted = new Intl.NumberFormat(
            'en-US',
            {
                style: 'currency', 
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        ).format(amount);
    }else {
        formatted = new Intl.NumberFormat(
            'en-US',
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        ).format(amount);
    }
    

    return formatted;
}
 
export default formatToMoney;